function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "per-path-1",
  points: "0 0.0004 26.1118 0.0004 26.1118 25 0 25"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(10.000000, 2.000000)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "per-mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#per-path-1"
})), /*#__PURE__*/React.createElement("path", {
  d: "M18.5238,6.5424 L7.5888,6.5424 C7.2908,6.5424 7.0488,6.3004 7.0488,6.0024 C7.0488,5.7054 7.2908,5.4644 7.5888,5.4644 L18.5238,5.4644 C18.8208,5.4644 19.0628,5.7054 19.0628,6.0024 C19.0628,6.3004 18.8208,6.5424 18.5238,6.5424 M18.5238,10.4994 L7.5888,10.4994 C7.2908,10.4994 7.0488,10.2574 7.0488,9.9594 C7.0488,9.6614 7.2908,9.4204 7.5888,9.4204 L18.5238,9.4204 C18.8208,9.4204 19.0628,9.6614 19.0628,9.9594 C19.0628,10.2574 18.8208,10.4994 18.5238,10.4994 M12.5898,14.0664 L7.5888,14.0664 C7.2908,14.0664 7.0488,13.8254 7.0488,13.5264 C7.0488,13.2294 7.2908,12.9874 7.5888,12.9874 L12.5898,12.9874 C12.8878,12.9874 13.1298,13.2294 13.1298,13.5264 C13.1298,13.8254 12.8878,14.0664 12.5898,14.0664 M17.0808,0.0004 L9.0318,0.0004 C4.0518,0.0004 -0.0002,4.3854 -0.0002,9.7744 C-0.0002,14.6994 3.3068,18.7484 7.6988,19.4404 L7.6988,23.9214 C7.6988,24.3614 7.9668,24.7584 8.3758,24.9224 C8.5058,24.9744 8.6428,25.0004 8.7778,25.0004 C9.0658,25.0004 9.3498,24.8844 9.5568,24.6674 L14.4608,19.5484 L17.0808,19.5484 C22.0598,19.5484 26.1118,15.1634 26.1118,9.7744 C26.1118,4.3854 22.0598,0.0004 17.0808,0.0004",
  fill: "#FEFEFE",
  mask: "url(#per-mask-2)"
})));

var SvgPersonalFeedback = function SvgPersonalFeedback(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "28px",
    viewBox: "0 0 45 28",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPersonalFeedback, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/personal-feedback.e7f109a9.svg";
export { ForwardRef as ReactComponent };